// TokenAuthorization.js
import axios from 'axios';
import { Base_Url } from '../../BaseUrl/BaseUrl';

// Helper function to handle authorization errors
const handleAuthorizationError = async error => {
  if (error?.response?.data?.message === 'Invalid credentials') {
    return error; // Rethrow error for handling in slice
  }
  if (error.response && error.response.status === 401) {
    const data = await deleteApiWithoutAuthorization(`${Base_Url}/logout`);
    if (data) {
      localStorage.clear();
      window.location.replace('/login');
    }
  }
  return error; // Rethrow error for handling in slice
};

// POST API with Authorization
export const postApiWithAuthorization = async (url, data) => {
  try {
    const storedAuth = JSON.parse(localStorage.getItem('login')); // Get token from Redux state
    const response = await axios.post(url, data, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${storedAuth.token}`, // Attach token dynamically
      },
    });
    return response.data; // Return response data directly
  } catch (error) {
    return handleAuthorizationError(error);
  }
};
export const patchApiWithAuthorization = async (url, data) => {
  try {
    const storedAuth = JSON.parse(localStorage.getItem('login')); // Get token from Redux state
    const response = await axios.patch(url, data, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${storedAuth.token}`, // Attach token dynamically
      },
    });
    return response.data; // Return response data directly
  } catch (error) {
    return handleAuthorizationError(error);
  }
};

// POST API without Authorization
export const postApiWithoutAuthorization = async (url, data) => {
  try {
    const response = await axios.post(url, data, {
      withCredentials: true, // ✅ important
    });
    return response.data; // Return response data directly
  } catch (error) {
    // Failed login must preserve the pending Events transaction for another attempt.
    if (url === `${Base_Url}/login`) return error;
    return handleAuthorizationError(error);
  }
};

// GET API with Authorization
export const getApiWithAuthorization = async url => {
  try {
    const storedAuth = JSON.parse(localStorage.getItem('login')); // Get token from Redux state
    const response = await axios.get(url, {
      withCredentials: true, // ✅ important
      headers: {
        Authorization: `Bearer ${storedAuth.token}`, // Attach token dynamically
      },
    });

    return response.data; // Return response data directly
  } catch (error) {
    return handleAuthorizationError(error);
  }
};

// GET API without Authorization
export const getApiWithoutAuthorization = async url => {
  try {
    const response = await axios.get(url, {
      withCredentials: true, // ✅ important
    });
    return response.data; // Return response data directly
  } catch (error) {
    // A logged-out session probe is expected on the login page, not a forced logout.
    if (url === `${Base_Url}/session-status`) return error;
    return handleAuthorizationError(error);
  }
};

// PUT API with Authorization
export const putApiWithAuthorization = async (url, data) => {
  try {
    const storedAuth = JSON.parse(localStorage.getItem('login'));
    const response = await axios.put(url, data, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${storedAuth?.token}`,
      },
    });
    return response.data;
  } catch (error) {
    return handleAuthorizationError(error);
  }
};

// put API without Authorization
export const putApiWithoutAuthorization = async (url, data) => {
  try {
    const response = await axios.put(url, data, {
      withCredentials: true, // ✅ important
    });
    return response.data; // Return response data directly
  } catch (error) {
    console.log(error);
    return handleAuthorizationError(error);
  }
};

// Delete API without Authorization
export const deleteApiWithoutAuthorization = async (url, data) => {
  try {
    const response = await axios.delete(url, {
      credentials: 'include',
      withCredentials: true,
      data: data,
    });
    return response.data; // Return response data directly
  } catch (error) {
    return error; // Handle error in calling function
  }
};

// Delete API with Authorization
export const deleteApiWithAuthorization = async (url, data) => {
  try {
    const storedAuth = JSON.parse(localStorage.getItem('login')); // Get token from Redux state
    const response = await axios.delete(url, {
      credentials: 'include',
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${storedAuth?.token}`, // Attach token dynamically
        'Content-Type': 'application/json',
      },
      data: data,
    });
    return response.data;
  } catch (error) {
    return handleAuthorizationError(error);
  }
};
